export default "assets/images/print.png";